import { useQuery } from '@tanstack/react-query';

import { getChannelsHealth, getFunnel, getSlaMetrics, type RangeFilters } from '../api/analytics';

export function useFunnel(filters: RangeFilters & { group_by?: 'channel' | 'agent' | 'scenario_version' }) {
  return useQuery({ queryKey: ['analytics', 'funnel', filters], queryFn: () => getFunnel(filters) });
}

export function useChannelsHealthAnalytics() {
  return useQuery({ queryKey: ['analytics', 'channels-health'], queryFn: getChannelsHealth });
}

export function useSlaMetrics(filters: RangeFilters) {
  return useQuery({ queryKey: ['analytics', 'sla', filters], queryFn: () => getSlaMetrics(filters) });
}
